import BaseViewModel, { Required } from '@/infrastructure/BaseViewModel';
import ScreenContent from './ScreenContent';

export default class Screen extends BaseViewModel {
    public Id: number = 0;
    public CustomerId: number | null = 0;
    @Required('Name cannot be null.')
    public Name: string = '';
    public Active: boolean = true;
    public Deleted: boolean = false;
    public DateCreated: Date = new Date();
    public DateUpdated: Date = new Date();
    public CustomerName: string = '';
    public Contents: ScreenContent[] = [];
}
